import { styled } from '@cad-arc';
import { colors } from '../../colors/colors';
export const EsriBasemapSwitchButton = styled('button')`
    position: absolute;
    bottom: 2px;
    left: 12px;
    border: none;
    text-decoration: underline;
    background-color: ${colors.mapBasemapSwitchBackground};
    color: ${colors.mapBasemapSwitchText};
    height: 20px;
    opacity: 0.7;
`;
